import { PDecimalPlaces } from "./PDecimalPlaces";

export function DecimalPlaces(aNumber, places) {
  if (typeof aNumber == "string") console.log("decplaces problem");

  return PDecimalPlaces(aNumber, places, false);
}
